import { createDashboardMutation } from '@akin-home/dashboards/frontend';
import { useMutation, useQueryClient } from 'react-query';
import { dashboard_query_keys } from './query_keys';

export const useCreateDashboard = () => {
  const query_client = useQueryClient();

  return useMutation(createDashboardMutation, {
    onSuccess() {
      query_client.invalidateQueries(dashboard_query_keys.lists());
    },
  });
};
